import React from 'react';
import { CheckIcon, SunIcon, ShieldCheckIcon, LockIcon, CreditCardIcon, ZapIcon } from 'lucide-react';
import { Countdown } from './Countdown';
import { trackPixelEvent } from '../hooks/useMetaPixel';
const includes = ['5 Tomos completos · Principiante → Experto', '5 Bonos estratégicos (valor $89 USD)', '100% PDF descargable · acceso de por vida'];
const trust = [{
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: CreditCardIcon,
  label: 'Tarjeta de débito o crédito'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}];
export function PricingSection() {
  return <section className="w-full scroll-mt-3 bg-ink-950 py-10 sm:py-16" id="precios" aria-labelledby="precios-title" style={{
    paddingTop: "18px",
    paddingBottom: "18px"
  }} data-id="element-130" data-mp="1xa1d7bldwqy4">
      <div className="mx-auto w-full max-w-4xl px-4 sm:px-6" data-id="element-131" data-mp="2vqrvd400ex3">
        <div className="text-center" data-id="element-132" data-mp="7tsaxy1fce8k">
          <h2 id="precios-title" className="font-display text-2xl font-900 leading-tight text-white sm:text-4xl" style={{
          fontSize: "28px"
        }} data-id="element-133" data-mp="7utjnvuywon4">
            Un solo pack. Todo incluido.
          </h2>
          <p className="mt-1.5 text-sm text-slate-400 sm:mt-3 sm:text-base" data-id="element-134" data-mp="1hodfuberjttd">
            Acceso de por vida. Sin suscripciones. Sin letra pequeña.
          </p>
        </div>

        <div className="mt-5 rounded-2xl border border-gold bg-ink-900 p-5 shadow-panel sm:mt-8 sm:p-9" data-id="element-135" data-mp="17sjvw6ypsy1k">
          <div className="grid gap-4 sm:grid-cols-[1fr_auto] sm:items-center sm:gap-8" data-id="element-136" data-mp="25ehiogk4npjb">
            <div data-id="element-137" data-mp="20g68u5tu1f13">
              <h3 className="font-display text-xl font-800 uppercase leading-tight tracking-wide text-white sm:text-3xl" data-id="element-138" data-mp="20hr27s4eurxd">
                Código Solar 360°
              </h3>

              <ul className="mt-3 grid gap-1.5 sm:mt-5 sm:gap-2.5" data-id="element-139" data-mp="1rgj5hehjlz5e">
                {includes.map(item => <li key={item} className="flex gap-2 text-sm leading-snug text-slate-200 sm:text-[15px] sm:leading-relaxed" data-id="element-140" data-mp="k2pinoahh7gs">
                    <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-leaf-400" aria-hidden="true" data-id="element-141" data-mp="fzt7gin9wdmv" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="flex items-baseline justify-center gap-3 border-t border-ink-800 pt-4 sm:min-w-[220px] sm:flex-col sm:items-center sm:gap-0 sm:border-l sm:border-t-0 sm:pl-8 sm:pt-0 sm:text-center" style={{
            paddingTop: "0px",
            paddingBottom: "0px",
            marginTop: "0px",
            marginBottom: "0px",
            gap: "14px"
          }} data-id="element-142" data-mp="mftb5g7oesxk">
              <p translate="no" className="whitespace-nowrap text-base text-slate-500 line-through sm:text-lg" style={{
              fontSize: "20px"
            }} data-id="element-143" data-mp="3i8ma94wvucy">
                $103 USD
              </p>
              <p className="font-display text-4xl font-900 leading-none text-gold sm:mt-1 sm:text-6xl" style={{
              fontSize: "48px",
              paddingTop: "6px",
              paddingBottom: "41px",
              paddingLeft: "0px",
              paddingRight: "0px",
              marginTop: "0px",
              marginBottom: "0px",
              marginLeft: "0px",
              marginRight: "0px",
              width: "70px",
              height: "36px"
            }} data-id="element-144" data-mp="3pymmdmczf5ok">
                $14
              </p>
              <p className="text-[10px] uppercase tracking-[0.2em] text-slate-400 sm:mt-2 sm:text-xs" style={{
              fontSize: "12px",
              paddingTop: "0px",
              paddingBottom: "0px",
              paddingLeft: "11px",
              paddingRight: "11px",
              marginTop: "0px",
              marginBottom: "0px",
              marginLeft: "0px",
              marginRight: "0px"
            }} data-id="element-145" data-mp="36d2wnxifo1o1">
                USD · Pago único
              </p>
            </div>
          </div>

          <a href="https://codigo-solar-360.impultienda.ar/checkout" onClick={() => trackPixelEvent('InitiateCheckout', {
          value: 17,
          currency: 'USD'
        })} className="mt-5 flex items-center justify-center gap-2 rounded-xl bg-gold px-6 py-3.5 font-display text-base font-800 uppercase tracking-wide text-ink-950 transition-[transform,background-color] duration-150 ease-smooth hover:bg-gold-400 active:scale-[0.985] sm:mt-8 sm:py-4 sm:text-lg" data-id="element-146" data-mp="3l2s94ovz7s3m">
            <SunIcon className="h-5 w-5" aria-hidden="true" data-id="element-147" data-mp="qrphkoy7r49g" />
            ✅ SÍ, QUIERO ACCESO INSTANTÁNEO AL CÓDIGO SOLAR 360° 

          </a>

          <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-[13px] text-slate-400" data-id="element-148" data-mp="3v4m8uu8i1ldl">
            {trust.map(item => <li key={item.label} className="flex items-center gap-1.5" data-id="element-149" data-mp="30aayjzem0se">
                <item.icon className="h-3.5 w-3.5 text-leaf-400" aria-hidden="true" data-id="element-150" data-mp="7zwner7erd05" />
                {item.label}
              </li>)}
          </ul>

          <p className="mt-3 text-center text-xs text-slate-400 sm:mt-4 sm:text-[13px]" data-id="element-151" data-mp="czsooioq0qc0">
            Tu pago es 100% seguro. Usamos encriptación SSL y Stripe como procesador de pagos.
 Tus datos nunca serán compartidos. 
Política de Privacidad | Términos de Servicio 
          </p>
        </div>

        <div className="mt-8 sm:mt-10" data-id="element-152" data-mp="38uvy1hncywrn">
          <Countdown label="Precio de lanzamiento — cierra en" note="Después sube el precio. No vuelve." progress={68} data-id="element-153" data-mp="38y1op1bmy6ph" />
        </div>
      </div>
    </section>;
}